const pageTitles = {
    home: '',
    main: 'Main',
    login: 'Login',
    passwordReset: 'Password Reset',
    register: 'Register',
    payment: 'Payment',
    changePassword: 'Change Password',
    overview: 'Overview',
    portfolio: 'Portfolio',
    equity: 'Equity',
    announcements: 'Announcements',
    comparative: 'Comparative',
    fourHundredFour: 'Error: 404',
    technicalScan: 'Technical Scan',
    DalalStreet: 'Dalal Street',
    Dashboard: 'Referral Dashboard',
    TermsAndConditions: 'Referral Terms And Conditions',
};

export default pageTitles;



// WEBPACK FOOTER //
// ./src/common/constants/pageTitles.js